// extracted by mini-css-extract-plugin
module.exports = {"demo":"Demo_demo__1Cuad","demo__button":"Demo_demo__button__MRm1_","demo__text":"Demo_demo__text__SHRPU"};